            function setCookie(name, value, minutes) {
                let expires = "";
                if (minutes) {
                    const date = new Date();
                    date.setTime(date.getTime() + (minutes * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            }

            function getCookie(name) {
                const nameEQ = name + "=";
                const ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }

            function generateUniqueAlphaNumericCode(length) {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                let code = '';
              
                for (let i = 0; i < length; i++) {
                  const randomIndex = Math.floor(Math.random() * characters.length);
                  code += characters.charAt(randomIndex);
                }
              
                return code;
            }
               
            const uniqueCode = generateUniqueAlphaNumericCode(4);

            function deleteCookie(name) {
                document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
            }

            function hasUTMParameters() {
                const urlParams = new URLSearchParams(window.location.search);
                const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
                return utmParams.some(param => urlParams.has(param));
            }

            var boton = document.getElementById('botonWh');
            let savedID;

            if (hasUTMParameters()) {
                const uniqueID = 'KR' + uniqueCode;
                const currentUrl = window.location.href;
                setCookie('urlWithUTM', currentUrl, 60);  // Guarda por 1 día
                setCookie('uniqueID', uniqueID, 60);  // Guarda por 1 hora
                savedUrl = currentUrl;
                savedID = uniqueID;
            } else {
                 savedUrl = getCookie('urlWithUTM');
                 savedID = getCookie('uniqueID');
            }

            if (savedUrl && savedID) {
              boton.href = "https://api.whatsapp.com/send?phone=5213337275863&text=" + savedID + " " + "¡Hola! Kingstar, tengo una duda, me puedes ayudar con el siguiente producto: " + window.location.href + "&type=phone_number&app_absent=0";
                //boton.href = "https://api.whatsapp.com/send?phone=5213321010525&text=¡Hola!Rhino, tengo una duda, me puedes ayudar con el siguiente producto: " + savedID + " " + window.location.href + "&type=phone_number&app_absent=0";
               // https://api.whatsapp.com/send?phone=5213321010525&text="+savedID+" "+"¡Hola! KitchenMax Store, tengo una duda, me puedes ayudar con el siguiente producto: "+window.location.href+"&type=phone_number&app_absent=0"
            } else {
               boton.href = "https://api.whatsapp.com/send?phone=5213337275863&text=¡Hola! Kingstar, tengo una duda, me puedes ayudar con el siguiente producto: "+window.location.href+"&type=phone_number&app_absent=0";
            }
          boton.addEventListener('click', function() {
            const finalURL = window.location.href;  // Captura la URL actual
            let urlWithUTM = getCookie('urlWithUTM');
    
    if (savedID && urlWithUTM) {
        sendDataToGoogleSheets({ uniqueID: savedID, urlWithUTM: urlWithUTM, finalURL: finalURL });
    }
    deleteCookie('uniqueID');
    deleteCookie('urlWithUTM');
            });

          function sendDataToGoogleSheets(data) {
    fetch('https://script.google.com/macros/s/AKfycbygQNuty3WxIR74Xyk89K8KQXJAbfkVCD_Pd18_vFmcTJcsZpVKVE4tVidPLdWlifHv/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

	
